<template>
  <v-text-field
    type="number"
    min="0"
    class="small-text-field "
    :required="required"
    :value="content"
    placeholder=" "
    :label="label"
    :height="28"
    style="width: 44px;"
    @input="updateSelf"
    :hide-details="valid() == true && (error == null || error.length == 0)"
    :error-messages="valid() == true ? null : [valid()] "
    outlined
    dense
  ></v-text-field>
</template>

<script>
export default {
  name: "SimpleNumberInput",
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    label: String,
    errorMessages: Object,
    content: Number,
    prependIcon: { type: String, default: null },
    error: String
  },
  data() {
    return {
      menu: false,
      required: false
    };
  },
  methods: {
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(content) {
      this.menu = false;
      this.$emit("input", content);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
